import { JSX } from "react/jsx-runtime";
import { PlanDialog } from "./PlanOverview/PlanDialog";
import { ConfirmLoadPendingInstanceDialog } from "./InstanceDialog/ConfirmLoadPendingInstanceDialog";

export function PlanLoadingDialogs(): JSX.Element {
  return (
    <div slot="leading">
      <PlanDialog buttonStyle="tertiary" />
      <ConfirmLoadPendingInstanceDialog />
    </div>
  );
}
